import type { GetStaticPaths, GetStaticProps, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { GroupDetails } from "views";
import { normalizeFaculty } from "utils/normalizer";
import translation from "views/Group/translation";
import { REVALIDATE_TIME, CACHE_TIME } from "utils/constants";
import { checkEmpty, isCorrectLocale } from "utils/newFunction";

function GroupDetailsPage({ data }) {
  return <GroupDetails data={data} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  query,
  locale,
}) => {
  const apiService = new ApiService(locale);
  const iumsId = params?.slug?.[0];
  const cmsGroupId = params?.slug?.[1];
  const cmsFacultyId = params?.slug?.[2];
  const slug = params?.slug?.[3];

  if (
    Number.isNaN(+iumsId) ||
    Number.isNaN(+cmsGroupId) ||
    Number.isNaN(+cmsFacultyId)
  ) {
    return {
      notFound: true,
    };
  }

  let tabCategory;

  const requests = [
    apiService.getFacultyById(cmsFacultyId, {
      cache: { key: cmsFacultyId, lifeTime: CACHE_TIME },
    }), // 0 CMS Faculty
    apiService.getGroupById(cmsGroupId, {
      // formatter: false,
      cache: { key: cmsGroupId, lifeTime: CACHE_TIME },
    }), // 1 CMS Group
  ];

  let response = [];
  try {
    response = await ApiService.multipleRequest(requests);
  } catch (e) {}
  // console.log("response1: ", response);

  if (!response?.[0]?.[0] || !response?.[1]?.[0]) {
    return {
      notFound: true,
    };
  }
  // console.log("response2: ");

  if (!isCorrectLocale(response?.[1]?.[0], locale)) {
    return {
      notFound: true,
    };
  }

  const CMSGroup = normalizeFaculty(response?.[1]?.[0]);

  if (+CMSGroup.iums_id !== +iumsId) {
    return {
      notFound: true,
    };
  }
  // console.log("response3: ");

  const tabContent = CMSGroup?.tabs?.find?.(
    (item) => item?.slug === query.slug?.[3]
  );

  if (
    !translation?.[locale]?.IUMS_TABS.map((item) => item?.slug).includes(
      query.slug?.[3]
    )
  ) {
    tabCategory =
      CMSGroup?.tabs?.find?.((item) => `${item?.id}` === query.slug?.[1])
        ?.name ||
      CMSGroup?.tabs?.[0]?.name ||
      null;
  }
  // console.log("response4: ");

  const CMSParentFaculty = normalizeFaculty(response?.[0]?.[0]);
  const allTabsData = CMSGroup?.tabs || [];

  if (!CMSParentFaculty?.tabs.find((item) => +item.id === +cmsGroupId)) {
    return {
      notFound: true,
    };
  }

  if (!allTabsData.find((item) => item?.slug === slug)) {
    return {
      redirect: {
        permanent: true,
        destination: `${locale === "fa" ? "" : "/en"}/groups/${
          iumsId || null
        }/${cmsGroupId || null}/${cmsFacultyId || null}/${encodeURIComponent(
          allTabsData?.[0]?.slug
        )}`,
      },
    };
  }
  // console.log("response5: ");

  return {
    props: {
      data: {
        normalizedGroupWithTabs: CMSGroup,
        CMSParentFaculty,
        tabCategory,
        tabContent: tabContent || null,
        allTabsData,
        cmsFacultyId: cmsFacultyId || null,
        cmsItemTypeId: CMSGroup?.ItemTypeId,
        metaTag: CMSGroup?.metaTag || {},
        changeLanguageLink: CMSGroup?.changeLanguageLink || "",
        breadcrumb: CMSGroup?.breadcrumb || [],
      },
    },
  };
};
export default GroupDetailsPage;
